import React from 'react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center bg-white pt-20">
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Foreground Image */}
          <div className="mb-8">
            <img 
              src="https://static.readdy.ai/image/bb7cd839b2007a448cb97128493d2d64/978f9b449681a7b1cd862f818db884ea.png"
              alt="Business Buyers Advantage - Professional Business Acquisition Services"
              className="w-full max-w-3xl mx-auto rounded-xl shadow-md object-contain opacity-95"
            />
          </div>
          
          {/* Content Below Image */}
          <div className="text-center text-gray-800">
            <p className="text-xl md:text-2xl mb-6 text-gray-700 leading-relaxed font-medium">
              Your Complete Guide to Successful Business Acquisitions
            </p>
            
            <p className="text-lg mb-10 text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Expert guidance from certified business brokers to help you find, evaluate, and purchase the perfect business opportunity within your budget and industry interests.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link 
                to="/consultation" 
                className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-line mr-2"></i>
                Schedule Free Consultation
              </Link>
              
              <Link 
                to="/services" 
                className="border-2 border-teal-500 text-teal-500 hover:bg-teal-500 hover:text-white px-8 py-4 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-arrow-right-line mr-2"></i>
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-teal-500 text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
